import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

export default function Contact() {
  const contactInfo = [
    {
      icon: Mail,
      title: 'Email',
      details: 'info@apkenpharma.com',
    },
    {
      icon: Phone,
      title: 'Phone',
      details: '+91 97375 74875',
    },
    {
      icon: MapPin,
      title: 'Address',
      details: 'India',
    },
    {
      icon: Clock,
      title: 'Business Hours',
      details: 'Monday - Friday',
    },
  ];

  return (
    <div className="min-h-screen contact-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-secondary/5 via-background to-primary/5 py-10 lg:py-10">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center space-y-6">
            <Badge className="bg-primary/10 text-primary hover:bg-primary/20 border-primary/20">
              Contact Us
            </Badge>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground font-['Space_Grotesk'] leading-tight contact-title">
              Get in Touch
            </h1>
            <p className="text-xl text-muted-foreground leading-relaxed">
              Have questions? We're here to help. Reach out to our team and we'll respond as soon as possible.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-10">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {contactInfo.map((info, index) => {
              const Icon = info.icon;
              return (
                <Card key={index} className="border-border text-center contact-card shadow-lg hover:shadow-xl transition-all duration-300 card-border-hover primary">
                  <CardContent className="p-6">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                      <Icon className="h-6 w-6 text-primary" />
                    </div>
                    <h3 className="font-semibold text-foreground mb-2 hover-underline">{info.title}</h3>
                    <p className="text-sm text-foreground mb-1">{info.details}</p>
                    <p className="text-sm text-muted-foreground">{info.subdetails}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}